import React from 'react';
import PropTypes from 'prop-types';

function NotFound({ details, buttonText, navigate }) {
  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center p-4'>
      <div className='max-w-md w-full text-center'>
        <div className='mb-8'>
          <h1 className='text-9xl font-bold text-primary mb-4'>404</h1>
          <h2 className='text-3xl font-bold text-gray-900 mb-4'>Page Not Found</h2>
          <p className='text-gray-600 mb-8'>{details}</p>
        </div>
        <button
          type='button'
          onClick={navigate}
          className='px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg'
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

NotFound.propTypes = {
  details: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default NotFound;
